module.exports = __webpack_public_path__ + "img/20190601135537703.7ee2c44a.png";